import { Box } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CustomButton from 'src/core/ui/CustomButton';
import { ReviewTextField, mergeFieldSx } from 'src/core/forms/FieldReview';
import type { ScannerController } from './useScanner';

const ScannerInput = ({ scanner }: { scanner: ScannerController }) => {
  const { config, value, inputRef, disabled, submitting, onChange, onKeyDown, submitFromInput } = scanner;
  const input = config.input;
  const button = config.submitButton;
  return (
    <Box sx={mergeFieldSx({ display: 'flex', alignItems: 'center', gap: 1, maxWidth: '100%' }, config.sx)}>
      {/* Scanning needs the real input ref and synchronous Enter value; ordinary CustomField does not forward them. */}
      <ReviewTextField id={config.id} name={config.id} inputRef={inputRef} label={input?.label} placeholder={input?.placeholder} size={input?.size} value={value} disabled={disabled} onChange={onChange} onKeyDown={onKeyDown} autoComplete={input?.autoComplete ?? 'off'} inputProps={{ 'aria-label': input?.ariaLabel ?? (typeof input?.label === 'string' ? input.label : 'Scan') }} sx={mergeFieldSx({ width: { xs: 180, sm: 300, md: 380 }, maxWidth: '100%' }, input?.sx)} />
      {button?.visible !== false && <CustomButton title={button?.title ?? 'Submit scan'} tooltipText={button?.tooltipText} size={button?.size ?? 'small'} iconButton={button?.iconButton ?? true} variant={button?.variant ?? 'outlined'} icon={button?.icon ?? <ArrowForwardIcon />} disabled={disabled} isSubmitting={submitting} onClick={() => { void submitFromInput('button'); }} />}
    </Box>
  );
};

export default ScannerInput;
